<app-loading *ngIf="isLoading"></app-loading>

<div class="logout" [ngStyle]="{'right': TopNavButtonType === 'button' ? '2%' : '4%'}">
  <span (click)="onLogout()" class="d-flex" *ngIf="TopNavButtonType === 'text'">
    <span style="padding-top: 2px;padding-right: 4px;" class="text-truncate" 
    matTooltip={{buttonText}}
    [innerHTML]="appDataService.getSanitizedContent((buttonText || displayName) ? 
    (displayName ? displayName :
    buttonText) : 'Exit')"></span>
    <mat-icon *ngIf="endButtonIcon" class="">{{endButtonIcon}}</mat-icon>
  </span>
  <button class="button-shadow exit" (click)="onLogout()" *ngIf="TopNavButtonType === 'button'">
    <mat-icon class="">{{endButtonIcon}}</mat-icon>
  </button>
</div>